"use client"

import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import SvgIcon from '@components/shared/svg-icons/SvgIcon'

import styles from './Messages.module.css'

// Menu „Więcej” rozmowy: przy przycisku (od 640 px) albo arkusz od dołu; strzałki, Esc, fokus wraca na przycisk.
// items: [{ key, label, icon, hint, danger }]
export default function MoreMenu ({ items, opener, title, onPick, onClose }) {
    const ref = useRef(null)
    const [pos, setPos] = useState(null)

    useLayoutEffect(() => {
        const r = opener?.getBoundingClientRect()
        setPos(r ? { top: r.bottom + 4, left: Math.max(8, r.right - 300) } : {})
    }, [opener])
    useEffect(() => { if (pos) ref.current?.querySelector('[role="menuitem"]')?.focus() }, [Boolean(pos)])

    useEffect(() => {
        const onKey = (e) => {
            const list = [...(ref.current?.querySelectorAll('[role="menuitem"]') || [])]
            const i = list.indexOf(document.activeElement)
            if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close() }
            if (e.key === 'ArrowDown') { e.preventDefault(); list[(i + 1) % list.length]?.focus() }
            if (e.key === 'ArrowUp') { e.preventDefault(); list[(i - 1 + list.length) % list.length]?.focus() }
            if (e.key === 'Tab') close()
        }
        document.addEventListener('keydown', onKey, true)
        return () => document.removeEventListener('keydown', onKey, true)
    })

    const close = (focus = true) => {
        onClose()
        if (focus && opener?.isConnected) setTimeout(() => opener.focus(), 0)
    }

    return (
        <>
            <div className={styles.backdrop} onClick={() => close()} />
            <div aria-label={title} className={styles.more} ref={ref} role="menu" style={pos || { visibility: 'hidden' }}>
                <div className={styles.moreHead}>
                    <b>{title}</b>
                    <button aria-label="Zamknij" className={styles.iconBtn} onClick={() => close()} type="button"><SvgIcon name="close" /></button>
                </div>
                <ul>
                    { items.map(item => (
                        <li key={item.key} role="none">
                            <button className={item.danger ? styles.moreDanger : undefined} onClick={() => { close(false); onPick(item.key) }} role="menuitem" type="button">
                                <SvgIcon name={item.icon} />
                                <span>{item.label}{ item.hint && <small>{item.hint}</small> }</span>
                            </button>
                        </li>
                    )) }
                </ul>
            </div>
        </>
    )
}
